import { useEffect } from "react";
import useTimer from "../../hooks/useTimer";
import { Row } from "antd";

type Props = {
  initialTimeStamp: number;
};

export default function Timer({ initialTimeStamp }: Props) {
  const [{ days, hours, minutes, seconds }, setInitialTimeStamp] = useTimer();

  useEffect(() => {
    if (initialTimeStamp) {
      setInitialTimeStamp(initialTimeStamp);
    }
    // eslint-disable-next-line
  }, [initialTimeStamp]);
  return (
    <>
      <Row justify={"center"}>
        <div className="my-session-header-container">
          <h5>
            🎉 Get ready to conquer your exam! This is your time to shine! 🌟
            You've got this! 🚀
          </h5>
          <h5 style={{ marginTop: 20 }}>Your exam begins in:</h5>
        </div>
      </Row>
      <Row justify={"center"}>
        <div className="my-session-timer-container">
          <div className="timer-container">
            <div className="time-container">{days}</div>
            <span>Days</span>
          </div>
          <div className="time-colon">:</div>
          <div className="timer-container">
            <div className="time-container">{hours}</div>
            <span>Hours</span>
          </div>
          <div className="time-colon">:</div>
          <div className="timer-container">
            <div className="time-container">{minutes}</div>
            <span>Minutes</span>
          </div>

          <div className="time-colon">:</div>
          <div className="timer-container">
            <div className="time-container">{seconds}</div>
            <span>Seconds</span>
          </div>
        </div>
      </Row>
    </>
  );
}
